import { useState } from 'react';

export const useShipmentPagination = (
  initialPage: number = 1,
  initialPageSize: number = 50
) => {
  const [page, setPage] = useState<number>(initialPage);
  const [pageSize] = useState<number>(initialPageSize);
  const [totalPages, setTotalPages] = useState<number | undefined>();
  const [totalShipments, setTotalShipments] = useState<number | undefined>();

  return {
    page,
    setPage,
    pageSize,
    totalPages,
    setTotalPages,
    totalShipments,
    setTotalShipments,
  };
};
